/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_Result_Save_FailedInputs */

const en_landing_studio_result_save_failed = /** @type {(inputs: Landing_Studio_Result_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The locked result was not saved to history. Download the current image to keep it.`)
};

const zh_landing_studio_result_save_failed = /** @type {(inputs: Landing_Studio_Result_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`锁定区域的结果尚未保存到历史，请先下载当前图片。`)
};

/**
* | output |
* | --- |
* | "The locked result was not saved to history. Download the current image to keep it." |
*
* @param {Landing_Studio_Result_Save_FailedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_result_save_failed = /** @type {((inputs?: Landing_Studio_Result_Save_FailedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_Result_Save_FailedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_result_save_failed(inputs)
	return zh_landing_studio_result_save_failed(inputs)
});
export { landing_studio_result_save_failed as "landing.studio.result_save_failed" }